import { useState } from "react";
import { Button } from "@/components/ui/button";
import WaitlistModal from "@/components/WaitlistModal";
import mapScreenshot from "@/assets/map-screenshot.png";

const MapPreviewSection = () => {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-gradient-to-b from-background to-muted">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-foreground">
                Interactive Trail
                <span className="text-transparent bg-gradient-to-r from-primary to-accent bg-clip-text">
                  {" "}Mapping
                </span>
              </h2>
              <p className="text-xl text-muted-foreground leading-relaxed">
                Explore trails enriched with real community data. See where others have 
                been, what they discovered, and plan your next adventure with insights 
                from fellow explorers.
              </p>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  Community-contributed adventures and photos
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  Trail details from real off-road experiences
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  Discover new destinations from fellow explorers
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  AI-researched trail descriptions and embedded video guides
                </li>
              </ul>
              <Button variant="hero" size="lg" className="text-lg px-8 py-6" onClick={() => setWaitlistOpen(true)}>
                Join the Waitlist
              </Button>
            </div>
            
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border">
                <img 
                  src={mapScreenshot} 
                  alt="Interactive trail map showing detailed trail segments, routes, and terrain data with search and filtering capabilities"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary/20 rounded-full blur-xl"></div>
              <div className="absolute -top-4 -left-4 w-32 h-32 bg-accent/20 rounded-full blur-xl"></div>
            </div>
          </div>
        </div>
      </section>
      
      <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} />
    </>
  );
};

export default MapPreviewSection;
